export default __webpack_public_path__ + "static/media/close.a24608c3.svg";